import React from 'react'
import { AssetsForAttributes } from './assetEditor'
import styled from 'styled-components'
import { pxToEm } from '../../../theme/stylesMixins'
import assetApi, {AssetType} from '../../../api/assetApi'
import { useAppDispatch } from '../../../hooks'
import { AMAModelConfig, AMAUpdateConfig, customObjects, utilsEditor } from '@amaspace-editor/editor-3d'

interface IAssetEditorAssetsProps {
    allAssets?: AssetsForAttributes
}

const AssetEditorAssets = ({ allAssets }: IAssetEditorAssetsProps) => {
    const dispatch = useAppDispatch()
    const editor = utilsEditor()
    const customModel = customObjects()

    const uploadAssetToScene = async (asset: AssetType) => {
        const { data } = (await dispatch(assetApi.endpoints.getAssetById.initiate({ id: asset.id }))) as any

        customModel.create.model({
            name: asset.name,
            modelId: data.assets[0].id,
            lazyLoad: true,
            modelData: structuredClone(data) as AMAModelConfig
        })
    }

    return (
        <StyledWrapper>
            {allAssets
                ? allAssets.allModels.map(model => {
                      return (
                          <StyledCard onClick={() => uploadAssetToScene(model)}>
                              <StyledCardImage src={model.preview} alt="" />
                              <StyledCardTitle>{model.name}</StyledCardTitle>
                          </StyledCard>
                      )
                  })
                : 'No assets'}
        </StyledWrapper>
    )
}

export default AssetEditorAssets

const StyledWrapper = styled.div`
    height: 100%;
    padding: ${pxToEm(20)};

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${pxToEm(150)}, 1fr));
    overflow: auto;
    gap: 20px;
`
const StyledCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;

    cursor: pointer;
`
const StyledCardTitle = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
const StyledCardImage = styled.img`
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #c6c6c6;
`
